export default "__VITE_ASSET__15eed285__"